import type { CSSProperties } from 'react'
import { cn } from '@/lib/cn'

export function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return <div className={cn('rounded-md bg-subtle motion-safe:animate-pulse', className)} style={style} aria-hidden />
}
